// ANT components
import { Upload } from "antd";
import { UploadChangeParam, UploadFile } from "antd/es/upload/interface";

// Components
import EmptyComponent from "components/atoms/EmptyComponent/EmptyComponent";
import getIcon from "utils/getIcon";
import { useMultipleFileUpload } from "./useMultipleFileUpload";

// constants
import { FILE_UPLOAD_CONSTANT as Constants } from "constants/global";
import { useAppDispatch } from "app/hooks/hooks";
import { filterFileList } from "redux/reimbursement/reimbursementSlice";

const { Dragger } = Upload;

export type UploadProp = {
	handleFileInput: (info: UploadChangeParam<UploadFile>) => void;
	accept: string;
	disabled?: boolean;
	files?: string[];
};

const MultipleFileUpload = ({ handleFileInput, accept, disabled, files }: UploadProp) => {
	const { beforeUpload } = useMultipleFileUpload(accept);

	const dispatch = useAppDispatch();

	const getFilename = (pathname: string) => {
		const fileNameStr = pathname.substring(pathname.lastIndexOf("/") + 1);
		const fileType = fileNameStr.substring(fileNameStr.lastIndexOf(".") + 1);
		const updatedFileName = fileNameStr.split("_").slice(0, 3).join("_");
		return `${updatedFileName}.${fileType}`;
	};

	const fileList: UploadFile<any>[] = [];

	if (files) {
		for (let i = 0; i < files?.length; i++) {
			fileList.push({ uid: i.toString(), name: getFilename(files[i]), url: files[i] });
		}
	}

	return (
		<Dragger
			id="multiple-file-upload"
			defaultFileList={fileList}
			multiple={true}
			accept={accept}
			disabled={disabled}
			listType="text"
			showUploadList={{
				showRemoveIcon: true,
				removeIcon: <div>{getIcon({ icon: "closeIcon" })}</div>
			}}
			onChange={handleFileInput}
			beforeUpload={beforeUpload}
			iconRender={EmptyComponent}
			maxCount={3}
			onRemove={
				fileList.length
					? (file) => {
							dispatch(filterFileList(file));
					  }
					: undefined
			}
		>
			<p className="ant-upload-text">
				{Constants.UPLOAD_TEXT} <br /> <u>{Constants.BROWSE}</u> <br /> {Constants.NOTE}
			</p>
		</Dragger>
	);
};

export default MultipleFileUpload;
